import {
  CustomerAddressesPage,
  CustomerDashboardPage,
  CustomerPreferencesPage,
  CustomerPrivacyPage,
  CustomerProfilePage,
  CustomerSectionPlaceholderPage,
} from '../components'
import type { CustomerProtectedRendererInput } from './types'

export const renderAccountRoutes = ({ onNavigate, viewModel }: CustomerProtectedRendererInput) => {
  const account = viewModel.account
  const profile = viewModel.profile

  if (!account || !profile) {
    return null
  }

  if (viewModel.isPrivacyRoute) {
    return (
      <CustomerPrivacyPage
        dashboard={viewModel.privacyDashboard}
        loading={viewModel.privacyLoading}
        refreshing={viewModel.privacyRefreshing}
        error={viewModel.privacyError}
        notice={viewModel.privacyNotice}
        exportRequesting={viewModel.exportRequesting}
        exportDownloading={viewModel.exportDownloading}
        consentsSaving={viewModel.consentsSaving}
        deletionSubmitting={viewModel.deletionSubmitting}
        onUpdateProfile={viewModel.updateProfile}
        onRefresh={viewModel.refreshPrivacyDashboard}
        onRequestExport={viewModel.requestPrivacyExport}
        onDownloadExport={viewModel.downloadPrivacyExport}
        onSaveConsents={viewModel.updatePrivacyConsents}
        onRequestDeletion={viewModel.requestAccountDeletion}
        onNavigate={onNavigate}
      />
    )
  }

  if (viewModel.isProfileRoute) {
    return (
      <CustomerProfilePage
        account={account}
        profile={profile}
        onUpdateProfile={viewModel.updateProfile}
        onNavigate={onNavigate}
      />
    )
  }

  if (viewModel.isAddressesRoute) {
    return (
      <CustomerAddressesPage
        profile={profile}
        onUpdateProfile={viewModel.updateProfile}
        onNavigate={onNavigate}
      />
    )
  }

  if (viewModel.isPreferencesRoute) {
    return (
      <CustomerPreferencesPage
        profile={profile}
        orders={viewModel.orders}
        ordersLoading={viewModel.ordersLoading}
        onUpdateProfile={viewModel.updateProfile}
        onNavigate={onNavigate}
      />
    )
  }

  if (viewModel.nestedPath) {
    return <CustomerSectionPlaceholderPage nestedPath={viewModel.nestedPath} onNavigate={onNavigate} />
  }

  return (
    <CustomerDashboardPage
      account={account}
      profile={profile}
      orders={viewModel.orders}
      ordersLoading={viewModel.ordersLoading}
      ordersError={viewModel.ordersError}
      supportRequests={viewModel.supportRequests}
      supportLoading={viewModel.supportLoading}
      supportError={viewModel.supportError}
      privacyDashboard={viewModel.privacyDashboard}
      onNavigate={onNavigate}
      onLogout={viewModel.handleLogout}
    />
  )
}
